<template>
    <div id="front_email">
        <hea/>
        <main class="main">
            <router-view />
        </main>
        <foote/>
    </div>
</template>

<script>
    import hea from "./head";
    import foote from "@/components/common/footer";

    export default {
        components: {
            hea,
            foote
        },
        watch: {
            $route(to, from) {
                if (to.path === '/email/query' && from.path.indexOf('/email/mail-detail') > -1) {
                    return;
                } else if (to.path.indexOf('/email/mail-detail') > -1) {
                    return;
                } else {
                    this.$store.commit('SET_QUERYSEARCH', null);
                }
            }
        },
        methods: {
            linkTo() {
                this.$router.push("/email/settings");
            }
        }
    };
</script>

<style lang="scss">
    @import './../../../assets/email/css/email.css';
    
    .main {
        height: calc(100vh - 124px);
        overflow: hidden;

        .el-dialog__header {
            padding: 20px;
            background-color: #348EFC;

            span,
            button i {
                color: #fff;
            }
        }
    }
</style>